import { useQuery } from "@apollo/client";
import { GET_PUBLIC_TOKEN } from "./commands";

export function useGetPublicToken() {
  const { data, loading } = useQuery(GET_PUBLIC_TOKEN, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-only",
    errorPolicy: "all",
  });

  return {
    token: data?.getPublicToken?.token,
    loading,
  };
}
